var _rect, _rect2, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgArbitrum = function SvgArbitrum(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 50,
    fill: "#2D374B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 50,
    fill: "url(#2D374B)",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.65 21.776 3.587 5.63 3.313-1.92-4.71-7.425-2.19 3.715Zm9.917 1.451-.002-1.538-5.147-8.016-1.91 3.24 4.969 8.035 1.796-1.04a.797.797 0 0 0 .294-.58v-.1ZM6 24.678l2.537 1.462 8.442-13.538-1.433-.038c-1.22-.017-2.536.3-3.14 1.285l-4.793 7.43L6 23.757v.921Zm15.851-12.076-3.776.014-8.543 14.097 2.986 1.72.812-1.378 8.521-14.453Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.158 12.582a2.405 2.405 0 0 0-1.129-1.933L18.642 5.25a2.442 2.442 0 0 0-2.154 0c-.078.04-9.129 5.289-9.129 5.289A2.407 2.407 0 0 0 6 12.577v11.18l1.613-2.478-.014-8.626a.794.794 0 0 1 .332-.6c.042-.03 9.247-5.358 9.276-5.373a.817.817 0 0 1 .708-.003l9.266 5.33c.22.14.357.376.37.635v10.686a.78.78 0 0 1-.278.58l-1.796 1.04-.927.537-3.313 1.92-3.36 1.948a.814.814 0 0 1-.572-.012l-3.975-2.286-.812 1.377 3.572 2.057.31.175c.134.075.225.125.257.14.254.124.62.196.948.196.302 0 .596-.055.875-.165l9.759-5.651c.56-.434.89-1.088.92-1.797V12.582Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 18 -18 0 18 18)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E384C"
  })))));
};
export default SvgArbitrum;